import React from "react";
import { useAppSelector } from "@/redux/hooks";
import { isSystemIntegratedSelector } from "@redux/features/auth/authSlice";
import { Alert } from "@mui/material";
import BaseIntegrationInject from "@reusables/BaseIntegrationInject";
import { Trans, useTranslation } from "react-i18next";

export default function POGOWarning() {
    const { t } = useTranslation("", { keyPrefix: "customers.general.tabs.address" });

    const isPOGOIntegrated = useAppSelector(isSystemIntegratedSelector("poweroffice"));

    if (!isPOGOIntegrated) {
        return null;
    }

    return (
        <Alert severity="warning" className="mt-[16px]" icon={
            <BaseIntegrationInject integration={"poweroffice"}>
                {
                    (integration, isLoading) =>
                        !isLoading ?
                            <img src={integration?.imageUrl} width={20} height={20}
                                 alt={integration?.name} /> : null
                }
            </BaseIntegrationInject>
        }>
           <Trans t={t} i18nKey="warnings.billingIsRecommendedByPOGO"/>
        </Alert>
    );
}